import { useLocation } from "react-router-dom";
import CraftIdentityMatchesSearch from "./CraftIdentityMatchesSearch";
import CraftIdentityMatchesSort from "./CraftIdentityMatchesSort";

const CraftIdentityMatchesActions = ({matchesLength, isMatchesLoading, updateMatchesRef, searchMatchesInput, setSearchMatchesInput, sortType, setSortType}) => {
  const {pathname} = useLocation();
  if ((pathname.includes('tutorial') && matchesLength > 0) || (matchesLength > 7 && !isMatchesLoading)) {
    return (
      <>
        <CraftIdentityMatchesSearch
          updateMatchesRef={updateMatchesRef}
          searchMatchesInput={searchMatchesInput}
          setSearchMatchesInput={setSearchMatchesInput}
        />
        <CraftIdentityMatchesSort
          sortType={sortType}
          setSortType={setSortType}
        />
      </>
    );
  }
};

export default CraftIdentityMatchesActions;
